export default "__VITE_ASSET__2wmcIB_6__"